import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

/**
 * The previous/next affordances of a full-screen detail view: an edge arrow on large screens, a
 * floating round chevron button on small ones.
 *
 * Each side renders only while the host says there is something to step to, and a click is
 * reported as-is — which notification "previous" and "next" point at is the host's business.
 */
@Component({
    selector: 'pace-notification-detail-navigation',
    imports: [FontAwesomeModule],
    templateUrl: './pace-notification-detail-navigation.component.html',
    styleUrls: ['./pace-notification-detail-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaceNotificationDetailNavigationComponent {
    public readonly showPrevious = input(false);
    public readonly showNext = input(false);

    public readonly previousSelect = output<void>();
    public readonly nextSelect = output<void>();

    public readonly faChevronLeft = faChevronLeft;
    public readonly faChevronRight = faChevronRight;
}
